// extracted by mini-css-extract-plugin
export default {"svg":"CancelOrderButton_svg__7N-Hj"};